// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a637778bbf469f5bd167","655":"5898962a30eb84dc0694"}[chunkId] + ".js";
};